import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { HiLocationMarker, HiChevronRight, HiPhone, HiChatAlt2 } from "react-icons/hi"
import { capitalize } from "../../../../helpers"
import Emulator from "../../../../components/emulator"
import defaultBackground from "../../../../assets/city_background.jpg"
import { getLocaleValue } from "../../../../helpers/getLocaleValue"
import type { DestinationFormValues } from "../../../../constants/types"

type SettingsPreviewProps = {
  data: DestinationFormValues
}

const SettingsPreview: React.FC<SettingsPreviewProps> = ({ data }) => {
  const { t } = useTranslation()
  const [lng, setPreviewLanguage] = useState("fi")

  const image = data.image
    ? typeof data.image === "string"
      ? data.image
      : URL.createObjectURL(data.image)
    : defaultBackground

  return (
    <Emulator lng={lng} setPreviewLanguage={setPreviewLanguage}>
      <div className="tw-h-full tw-w-full tw-rounded-[25px] tw-bg-light">
        {/* Image */}
        <div className="tw-relative tw-h-[247px] tw-w-full tw-bg-dark-25 tw-rounded-t-[25px]">
          <img alt="" src={image} className="tw-h-full tw-w-full tw-object-cover tw-rounded-t-[25px]" />
        </div>
        {/* Text */}
        <div className="tw-absolute tw-top-48 tw-px-[15px]">
          <div className="tw-bg-white tw-border tw-rounded-2xl tw-p-2.5 tw-w-[260px]">
            <div className="tw-text-xs tw-text-dark tw-mb-2">
              <HiLocationMarker className="tw-text-sm tw-mr-2" />
              {data.streetName}, {capitalize(data?.city)}
            </div>
            <div className="tw-text-xs tw-mb-2">
              {getLocaleValue(data, "description", lng) && (
                <p className="tw-text-xs tw-text-dark-75 tw-line-clamp-6">{getLocaleValue(data, "description", lng)}</p>
              )}
            </div>
            <div className="tw-flex tw-space-x-2">
              {data.displayCall && (
                <button
                  type="button"
                  className="tw-w-1/2 tw-btn tw-h-[32px] tw-min-w-[20px] tw-btn-primary tw-flex tw-items-center
                    tw-justify-start">
                  <HiPhone className="tw-text-sm" />
                  <span className="tw-text-sm">{t("settings.emulator.call", { lng })}</span>
                </button>
              )}
              {data.displayMessage && (
                <button
                  type="button"
                  className="tw-w-1/2 tw-btn tw-h-[32px] tw-min-w-[20px] tw-btn-primary tw-flex tw-items-center
                    tw-justify-start">
                  <HiChatAlt2 className="tw-text-sm" />
                  <span className="tw-text-sm">{t("settings.emulator.message", { lng })}</span>
                </button>
              )}
            </div>
          </div>
          {["1", "2", "3", "4", "5"].map(item => (
            <div
              key={item}
              className="tw-flex tw-w-full tw-h-9 tw-mt-2.5 tw-px-4 tw-bg-white tw-border tw-rounded-2xl tw-shadow
                tw-items-center tw-justify-between">
              <span className="tw-text-sm">{t("settings.emulator.guide", { value: item, lng })}</span>
              <HiChevronRight className="tw-text-sm" />
            </div>
          ))}
        </div>
      </div>
    </Emulator>
  )
}

export default SettingsPreview
